

import { mapState, mapStores } from 'pinia';
import { defineComponent } from 'vue';

import ComponentBase from '~/components/component-base';
import { useWidgetStore } from '~/store/widgets.store';

export default defineComponent({

    extends: ComponentBase,

    computed: {
        ...mapStores(useWidgetStore),
        ...mapState(useWidgetStore, ["widgets"]),
    },

});

